import React from "react";
import {Link} from "@material-ui/core";

export default ({ props: cProps, to: to, text: text, ...rest }) =>
    <Link href="#" onClick={() => {cProps.history.push(to)}} {...rest}>
        {text}
    </Link>
